/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Idea_TitleInputs */

const en_idea_title = /** @type {(inputs: Idea_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tell us your idea`)
};

const id_idea_title = /** @type {(inputs: Idea_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ceritakan idemu`)
};

/**
* | output |
* | --- |
* | "Tell us your idea" |
*
* @param {Idea_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const idea_title = /** @type {((inputs?: Idea_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Idea_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_idea_title(inputs)
	return en_idea_title(inputs)
});